<template>
	<div id="finishDetails" style="margin-top: 20px;">
		<p class="back_box" @click="$router.go(-1)" v-if="this.$route.name != 'caseDetails'">
			<img src="../../../static/images/back.png"/>
			返回上一页
		</p>
		<h3 class="titleH3">{{caseDetails.victimList[0].obj.victimName}}的{{caseDetails.incidentTypeStr}} 案件档案 -案件编号：{{caseDetails.obj.caseNo}}({{caseDetails.obj.regulatorId}})</h3>
		<ul class="nav" v-if="false">
			<li class="active">案件基本信息</li>
			<li>服务清单</li>
			<li>案件轨迹(救援开始前)</li>
			<li>案件轨迹(救援开始后)</li>
			<li>费用清单</li>
			<li>工作台记录</li>
		</ul>
		<div class="coutent"  >
			<p class="first">一、案件基本信息</p>
			<div class="jbxx">
				<p class="second">A、案件基本信息</p>
				<ul>
					<li>报案时间：{{setTime(caseDetails.obj.reportTs)|| '- -'}}</li>
					<li>报案人：{{caseDetails.obj.reportUser|| '- -'}}</li>
					<li>报案电话：{{caseDetails.obj.reporterContact|| '- -'}}</li>
					<li>证件号码：{{caseDetails.victimList[0].obj.idNo || '--'}}</li>
					<li>性别：{{caseDetails.victimList[0].obj.gender == 1 ? '男':'女'}}</li>
					<li v-if="typeId != 800">出险时间：{{setTime(caseDetails.obj.incidentTs)|| '- -'}}</li>
          <li v-else>报案时间：{{setTime(caseDetails.obj.reportTs)|| '- -'}}</li>
					<li>所属保险公司：{{caseDetails.victimList[0].insuranceCompany|| '- -'}}</li>
					<li>案件来源：{{caseDetails.obj.caseSrc|| '- -'}}</li>
					<li>来源说明：{{setTxt(caseDetails.obj.caseSrcDesc) || '- -'}}</li>
				</ul>
			</div>
      <div class="jbxx jbxx1"  v-if="typeId == 900">
				<p class="second">B、出险信息</p>
				<ul>
					<li>出险地：{{caseDetails.caseCountry}} {{caseDetails.caseCity}} {{setTxt(caseDetails.generalLocation.addr)}}</li>
					<li>出险人：{{caseDetails.victimList[0].obj.victimName|| '- -'}}</li>
					<li  style="text-overflow: normal;overflow: auto;white-space: normal;width: 100%;">事故经过：{{setTxt(caseDetails.obj.incidentDesc) || '- -'}}</li>
          <li  style="text-overflow: normal;overflow: auto;white-space: normal;width: 100%;">救援需求：{{setTxt(caseDetails.obj.rescueInfo) || '- -'}}</li>
				</ul>
			</div>
			<div class="jbxx jbxx1"  v-else>
				<p class="second">B、出险信息</p>
				<ul>
					<li>出险地：{{caseDetails.caseCountry}} {{caseDetails.caseCity}} {{setTxt(caseDetails.generalLocation.addr)}}</li>
					<li>出险人：{{caseDetails.victimList[0].obj.victimName|| '- -'}}</li>
					<li v-if="typeId != 800">事故类型：{{caseDetails.obj.accidentType|| '- -'}}</li>
          <li v-else> 服务类型：{{caseDetails.obj.accidentType|| '- -'}}</li>
					<li v-if="typeId != 800">受伤部位：{{setTxt(caseDetails.victimList[0].obj.injuredPart)|| '- -'}}</li>
					<li v-if="typeId != 800" style="text-overflow: normal;overflow: auto;white-space: normal;width: 100%;">事故经过：{{setTxt(caseDetails.obj.incidentDesc) || '- -'}}</li>
          	<li v-else style="text-overflow: normal;overflow: auto;white-space: normal;width: 100%;">服务经过：{{setTxt(caseDetails.obj.incidentDesc) || '- -'}}</li>
				</ul>
			</div>
<!-- 			<div class="jbxx">
				<p class="second">C、联系人信息</p>
				<ul>
					<li>报案时间：2015-10-20</li>
				</ul>
			</div> -->
		</div>
		<div class="coutent" v-if="this.detailList.obj2">
			<p class="first">二、服务清单</p>
			<div class="jbxx fwqd">
				<p class="second">{{stepData[0].dict.name}}：</p>
				<p :class="item.obj.state &&  item.obj.state == 1 ? 'img':'imgNo'" v-for="(item,index) in stepData" v-if="index >0">{{item.dict.name}}</p>
			</div>
		</div>
		<div class="coutent" >
			<p class="first">三、案件轨迹（案件开始前）</p>
			<div class="table">
				<el-table :data="tableData1" style="width: 100%">
					<el-table-column label="时间">
						<template slot-scope='scope'>
							{{setTime(scope.row.obj.updateAt)}}
						</template>
					</el-table-column>
					<el-table-column label="操作方">
						<template slot-scope='scope'>
							{{nameData[scope.row.obj.operatorType]}}
							{{scope.row.instiName}}
						</template>
					</el-table-column>
					<el-table-column label="操作节点">
						<template slot-scope='scope'>
							{{scope.row.obj.opStateText}}
						</template>
					</el-table-column>
					<el-table-column label="操作细节">
						<template slot-scope='scope'>
							{{setTxt(scope.row.obj.opDesc)}}
						</template>
					</el-table-column>
					<el-table-column label="详细流程" width="300" show-overflow-tooltip>
						<template slot-scope='scope'>
							<p v-for="(item,index) in scope.row.moreTime">{{item}} {{setTxt(scope.row.moredetail[index])}}</p>
						</template>
					</el-table-column>
					<el-table-column label="相关单据及图片">
						<template slot-scope='scope' v-if="scope.row.obj.opPhotoUrlsArr">
              <isJpg :listArr='scope.row.obj.opPhotoUrlsArr' />
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<div class="coutent" >
			<p class="first">四、案件轨迹（案件开始后）</p>
			<div class="table">
				<el-table :data="tableData" style="width: 100%">
					<el-table-column label="时间">
						<template slot-scope='scope'>
							{{setTime(scope.row.obj.updateAt)}}
						</template>
					</el-table-column>
					<el-table-column label="操作方">
						<template slot-scope='scope'>
							{{nameData[scope.row.obj.operatorType]}}
							{{scope.row.instiName}}
						</template>
					</el-table-column>
					<el-table-column label="操作节点">
						<template slot-scope='scope'>
              <span v-if="scope.row.obj.opStateText.substr(0,4) == '回访内容'">
                <b style="color:red">{{scope.row.obj.opStateText}}</b>
              </span>
							<span v-else>
                {{scope.row.obj.opStateText}}
              </span>
						</template>
					</el-table-column>
					<el-table-column label="操作细节">
						<template slot-scope='scope'>
							{{setTxt(scope.row.obj.opDesc)}}
						</template>
					</el-table-column>
					<el-table-column label="详细流程" width="300" show-overflow-tooltip>
						<template slot-scope='scope'>
							<p v-for="(item,index) in scope.row.moreTime">{{item}} {{setTxt(scope.row.moredetail[index])}}</p>
						</template>
					</el-table-column>
					<el-table-column label="相关单据及图片">
						<template slot-scope='scope' v-if="scope.row.obj.opPhotoUrlsArr">
							<isJpg :listArr='scope.row.obj.opPhotoUrlsArr' />
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<div class="coutent" >
			<p class="first">五、费用核算</p>
			<el-radio-group v-model="labelForFive" style="text-align: center;margin: 0 auto;display: block;">
				<el-radio-button label="1">最终服务商</el-radio-button>
				<el-radio-button label="2" :disabled='otherFeeBoss.length == 1 || otherFeeBoss.length == 0'>其他未采纳报价</el-radio-button>
			</el-radio-group>
       
			<ul class="area" v-if="labelForFive==1">
				<li v-if="mongeyObj.totalFee">
					<p>服务商报价</p>
					<div>
						<p>整体报价:<span>{{mongeyObj.totalFee}} {{mongeyObj.currency}}</span></p>
						<p v-if="typeId != 800">医疗垫付:<span>{{mongeyObj.medicFee}} {{mongeyObj.currency}}</span></p>
						<p v-if="typeId != 800">案件费用:<span>{{mongeyObj.caseFee}} {{mongeyObj.currency}}</span></p>
						<p>救援费用:<span>{{mongeyObj.rescueFee}} {{mongeyObj.currency}}</span></p>
					</div>
				</li>
				<li v-if="shijiMoney.totalFee">
					<p>实际费用</p>
					<div>
						<p  v-if="typeId == 800">整体报价:<span>{{shijiMoney.rescueFee}} {{shijiMoney.currency}}</span></p>
            <p  v-if="typeId != 800">整体报价:<span>{{shijiMoney.totalFee}} {{shijiMoney.currency}}</span></p>
						<p v-if="typeId != 800">医疗垫付:<span>{{shijiMoney.medicFee}} {{shijiMoney.currency}}</span></p>
						<p v-if="typeId != 800">案件费用:<span>{{shijiMoney.caseFee}} {{shijiMoney.currency}}</span></p>
						<p>救援费用:<span>{{shijiMoney.rescueFee}} {{shijiMoney.currency}}</span></p>
						<p v-if="typeId != 800">客户自费:<span>{{shijiMoney.otherFee}} {{shijiMoney.currency}}</span></p>
            		<p v-if="typeId == 800">客户自费:<span>{{shijiMoney.medicFee}} {{shijiMoney.currency}}</span></p>
            	<p v-if="typeId != 800">案件服务费用:<span>{{shijiMoney.caseFee}}</span></p>
						<p class="long">其他费用说明:<span style="color: #999;">{{setTxt(shijiMoney.otherFeeDesc)}}</span></p>
					</div>
				</li>
				<li v-if="afterMoney.totalFee">
					<p>应收保险公司费用</p>
					<div>
						<p v-if="typeId != 800">整体报价:<span>{{afterMoney.totalFee}} {{afterMoney.currency}}</span></p>
						<p v-if="typeId != 800">医疗垫付:<span>{{afterMoney.medicFee}} {{afterMoney.currency}}</span></p>
						<p v-if="typeId != 800">救援费用:<span>{{afterMoney.rescueFee}} {{afterMoney.currency}}</span></p>
						<p v-if="typeId != 800">其他费用:<span>{{afterMoney.otherFee}} {{afterMoney.currency}}</span></p>

            	<p v-if="typeId == 800">保司合作费用:<span>{{afterMoney.rescueFee + afterMoney.otherFee}} {{afterMoney.currency}}</span></p>
						<p v-if="typeId == 800">成本费用:<span>{{afterMoney.rescueFee}} {{afterMoney.currency}}</span></p>
            	<p v-if="typeId == 800">纯收入:<span>{{afterMoney.otherFee}} {{afterMoney.currency}}</span></p>
					</div>
				</li>
			</ul>

			<ul class="area" v-if="labelForFive==2">
				<li v-for="item in otherFeeBoss" v-if="!item.check">
					<p >{{item.insti.name}}</p>
					<div>
						<p>整体报价:<span>{{item.solution.totalFee}} {{item.solution.currency}}</span></p>
						<p>医疗垫付:<span>{{item.solution.medicFee}} {{item.solution.currency}}</span></p>
						<p>案件费用:<span>{{item.solution.caseFee}} {{item.solution.currency}}</span></p>
						<p>救援费用:<span>{{item.solution.rescueFee}} {{item.solution.currency}}</span></p>
					</div>
				</li>
			</ul>
      <div>备注:{{  afterMoney.closeText}}</div>
		</div>
		<div class="coutent" >
			<p class="first">六、工作台相关记录</p>
 			<!-- <div class="item"><span>聊天记录 </span><router-link style="text-decoration: none;color: #00abfa;" :to="{path:'/cmd_center/caseindex/chatRecord',query:{caseid:caseid}}">查看详情</router-link></div>
			<div class="item"><span>视频记录 </span><router-link style="text-decoration: none;color: #00abfa;" :to="{path:'/cmd_center/caseindex/videoList',query:{caseid:caseid}}">查看详情</router-link></div> -->
			<div class="item"><span>案件附件列表 </span><router-link style="text-decoration: none;color: #00abfa;" :to="{path:'/cmd_center/caseindex/anjianList',query:{caseid:caseid,caseState:this.caseState}}">查看详情</router-link></div>
		</div>
		<el-dialog title="附件查看" :visible.sync="centerDialogVisible3" center>
			<el-carousel :interval="4000" type="card" height="200px">
				<el-carousel-item v-for="(item,index) in fileArrurl" :key="index" v-if="item.status == 1">
				  <img style="width: 100%;" :src="item.url">
				</el-carousel-item>
			</el-carousel>
		</el-dialog>
	</div>
</template>

<script>
	import { getCasedetail,caseProgress,getNodeDataRegulator,listBidding } from '@/views/axios/api.js'
	import constants from '@/util/constants.js';
	export default{
		data(){
			return{
        typeId:'',
				token:JSON.parse(window.localStorage.getItem("data")).data,
				caseDetails:{
					generalLocation:{},
					obj:{},
					victimList:[
						{obj:{}}
					]
				},
				stepData:[
					{dict:{}}
				],
				tableData: [],//案件开始后
				tableData1: [],//案件开始前
				nameData:['供应商','','监管机构'],
				centerDialogVisible3:false,
				fileArrurl:[],
				labelForFive:'1',
				mongeyObj:{},
				shijiMoney:{},
				afterMoney:{},
				otherFeeBoss:[],
				caseid:'',
				caseState:''
			}
		},
    props:[
      'detailList',
      'caseId'
    ],
    mounted() {
      this.caseid=this.$route.query.caseid;
      console.log(this.detailList);
      if(this.$route.name != 'caseDetails' && this.$route.name != 'createDetails'){
        return this.getData()
      } else{
        if(this.detailList.obj.obj.incidentType == '' ) return
        this.getCopss()
        console.log(this.detailList);
        this.caseDetails=this.detailList.obj;
        this.stepData=this.detailList.obj2;
        this.afterMoney=this.detailList.obj.obj;
        this.caseState=this.detailList.obj.obj.caseState;
        if(this.detailList.obj.feelst.length == 0 ) return
        this.shijiMoney = this.detailList.obj.feelst[0];
      }
    },
		methods:{
			setTxt(str, status) {
				if (constants.setTxt(str, status)) {
					return constants.setTxt(str, status);
				} else {
					return str;
				}
			},
			setTime(str){
				return constants.time(str)
			},
      getCopss(){
        this.tableData=[]
        this.tableData1=[]
        var data={
        	token:this.token,
        	caseId:this.caseId || this.$route.query.caseid
        }
        caseProgress(data)
        .then(res => {
        	console.log(res);
        	var reg = /(.*)\.(jpg|gif|bmp|png)$/;
        	res.data.obj.reverse();
        	res.data.obj.forEach(item => {
        		if(item.obj.opPhotoUrls){
        			item.obj.opPhotoUrlsArr=JSON.parse(item.obj.opPhotoUrls);
        			item.obj.opPhotoUrlsArr.forEach( item1 => {
        				if(reg.test(item1.url)){
        					item1.status=1
        				}else{
        					item1.status=0
        				}
        			})
        		}
        	})
        	res.data.obj.forEach(item => {
        		if(item.dict.chkPt<=90){
        			this.tableData1.push(item)
        		}else{
        			this.tableData.push(item)
        		}
        	})

        	console.log(this.tableData)

        })
        .catch( err => {
        	console.log(err)
        })
        console.log(this.detailList.obj.obj.caseState);
        getNodeDataRegulator(data)
        .then(res => {
          if(!res.data.obj){
            this.mongeyObj = {}
            this.labelForFive =1
            this.otherFeeBoss=[]
            return
          }
        	this.mongeyObj=res.data.obj;
        	listBidding(data)
        	.then(res => {
        		this.otherFeeBoss=res.data.obj;
        		this.otherFeeBoss.forEach(item => { //mongeyObj
              if(!item.solution) return
        			if(item.solution.id == this.mongeyObj.id){
        				item.check=true
        			}
        		})
        	})
        	.catch( err => {
        		console.log(err)
        	})
        })
        .catch( err => {
        	console.log(err)
        })
      },
			getData(){
				var data={
					token:this.token,
					caseId:this.$route.query.caseid
				}
				getCasedetail(data)
				.then(res => {
					console.log(res);
					this.caseDetails=res.data.obj;
					this.stepData=res.data.obj2;
					this.shijiMoney = res.data.obj.feelst[0];
					this.afterMoney=res.data.obj.obj;
					this.caseState=res.data.obj.obj.caseState;

				})
				.catch( err => {
					console.log(err)
				})
				caseProgress(data)
				.then(res => {
					console.log(res);
					var reg = /(.*)\.(jpg|gif|bmp|png)$/;
					res.data.obj.reverse();
					res.data.obj.forEach(item => {
						if(item.obj.opPhotoUrls){
							item.obj.opPhotoUrlsArr=JSON.parse(item.obj.opPhotoUrls);
							item.obj.opPhotoUrlsArr.forEach( item1 => {
								if(reg.test(item1.url)){
									item1.status=1
								}else{
									item1.status=0
								}
							})
						}
					})
					res.data.obj.forEach(item => {
						if(item.dict.chkPt<=90){
							this.tableData1.push(item)
						}else{
							this.tableData.push(item)
						}
					})

					console.log(this.tableData)

				})
				.catch( err => {
					console.log(err)
				})

				getNodeDataRegulator(data)
				.then(res => {
					this.mongeyObj=res.data.obj;
					listBidding(data)
					.then(res => {
						this.otherFeeBoss=res.data.obj;
						this.otherFeeBoss.forEach(item => { //mongeyObj
              if(!item.solution) return
							if(item.solution.id == this.mongeyObj.id){
								item.check=true
							}
						})
					})
					.catch( err => {
						console.log(err)
					})
				})
				.catch( err => {
					console.log(err)
				})


			}
		},
    watch:{
      detailList(){
        console.log(this.detailList);
        
        if(this.detailList.obj.obj.incidentType == '') return
        this.typeId = this.detailList.obj.obj.incidentType
        this.getCopss()
        console.log(this.detailList);
        this.caseDetails=this.detailList.obj;
        this.afterMoney=this.detailList.obj.obj;
        this.caseState=this.detailList.obj.obj.caseState;
        if(this.detailList.obj2){
          this.stepData=this.detailList.obj2;
        }
        if(!this.detailList.obj.feelst || this.detailList.obj.feelst.length == 0 ) return
        this.shijiMoney = this.detailList.obj.feelst[0];
      }

    }
	}
</script>

<style scoped="scoped">
.titleH3 {
	margin: 10px 0;
	font-weight: normal;
	text-align: center;
}
.nav {
	display: flex;
	justify-content: space-between;
	background: #f2f5f8;
	padding: 5px 10px;
	margin-top: 20px;
}
.nav li {
	cursor: pointer;
	padding: 10px;
}
.active {
	background: white;
	color: #22b6fb;
}
.first {
	margin-top: 20px;
	font-size: 18px;
	margin-bottom: 20px;
}
.jbxx {
	margin-left: 35px;
	margin-top: 10px;
}
.jbxx ul {
	margin-left: 25px;
	overflow: hidden;
	min-width: 900px;
}
.jbxx ul >li {float: left;width: 30%;margin-top: 10px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}
.jbxx1 ul >li{width: 50%;}
.fwqd {
	overflow: hidden;
}
.fwqd p {
	float: left;
	margin-right: 10px;
}
.fwqd .img {
	background: url(../../assets/img/checkyes.png) no-repeat left center;
	padding-left: 20px;
}
.fwqd .imgNo {
	background: url(../../assets/img/checkno.png) no-repeat left center;
	padding-left: 20px;
}
.table{margin-top: 20px;}
.img1{width: 40px;}
.item{
	float: left;
	color: #666;
	font-size: 16px;
	width: calc(30% - 20px);
}
.item span{
	padding-right: 20px;
}
ul.area{
  width: 100%;
  margin-top: 30px;
}
ul.area li{
  overflow: hidden;
  margin-bottom: 20px;
}
ul.area li > p{
 margin-bottom: 10px;
}
ul.area li > div{
	width: calc(100% - 130px);
	overflow: hidden;
	margin-left: 30px;
}
ul.area li > div > p{
	float: left;
	width: 205px;
	padding-bottom: 10px;
}
ul.area li > div > p.long{
	width: 400px;
}
ul.area li > div > p span{
	color: #ff7200;
}
</style>



// WEBPACK FOOTER //
// src/components/cmd_center/finishDetails.vue